import React from 'react';
import Select from 'react-select';
import axios from 'axios';

class Rule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            value:'chocolate',
            initialProducts:{},
        }

        this.getOptions = this.getOptions.bind(this);
        this.parseValue = this.parseValue.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }

    handleSelectChange (value) {
        console.dir(value);
        console.log('You\'ve selected:', value);
        this.setState({ value });
    }

    parseValue(values) {
        if(typeof values == 'string') {
            let ret = [];
            values.split(',').map(value => {
                ret.push({
                    id:value,
                    name:this.state.initialProducts[value]
                })
            });
            return ret;
        }

        return values;

    }

    fetchData() {
        if(this.props.rule.value === false || this.props.rule.value == 'false') {
            this.setState({isLoading:false});
            return;
        }
        axios.get('/popups?id='+this.props.rule.value).then(res => {
            let products = {};

            res.data.map(p => {
                products[p.id] = p.name;
            });

            this.setState({
                isLoading:false,
                initialProducts:products
            });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.rule.id != prevProps.rule.id) {
            this.setState({isLoading:true});
            this.fetchData();
        }
    }

    componentWillMount() {
        if(!this.props.rule.value || this.props.rule.value == '') {
            this.setState({isLoading:false});
            return true;
        }

        this.fetchData();
    }

    getOptions(value) {
        let param = 'id='+this.props.rule.value;

        if(value) {
            param = 'name='+value;
        }
        return axios.get('/popups?'+param).then(res => {
            let products = {
                ...this.state.initialProducts
            };

            for(let i in res.data) {
                products[res.data[i].id] = res.data[i].name;
            }

            this.setState({
                initialProducts:products
            });

            return {options:res.data};
        });
    }

    render() {
        return (
            <div>
                {this.state.isLoading ? null:
                    <Select.Async

                        autoload={true}
                        valueKey="id"
                        labelKey="name"
                        simpleValue={false}
                        multi={true}
                        name="form-field-name"
                        value={this.parseValue(this.props.rule.value)}
                        loadOptions={this.getOptions}
                        onChange={(e) => this.props.handleRuleChange(this.props.index,'operator',e)}
                    />}


            </div>
        );
    }


}

export default Rule;




// WEBPACK FOOTER //
// ./containers/segments/Rules/PopupPicker.js